import { lazy } from 'react';

const GeneralSettings = lazy(() => import('./GeneralSettings'));

const GeneralSettingsAppConfig = {
	settings: {
		layout: {}
	},
	routes: [
		{
			path: '/apps/frontend-settings/general-settings',
			element: <GeneralSettings />
		}
	]
};

export default GeneralSettingsAppConfig;
